import { Component, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs';
import { ValidationService } from '../validation.service';
import { TimeService } from '../time.service';

@Component({
  selector: 'app-rate-card-basic',
  templateUrl: './rate-card-basic.component.html',
  styleUrls: ['./rate-card-basic.component.scss']
})
export class RateCardBasicComponent implements OnInit {

  showLoader = false;
  tabIndex = 0;
  /*columnsToDisplayBasic: string[] = ['date', 'from', 'to', 'fare', 'additionalCharges', 'shipperId']
  rateCardBasicArr = [
    { date:'01-06-2019', from:'Mumbai', to:'Bengaluru', fare:'38,000', additionalCharges:'8,500', shipperId:'ShipperID#',},
    { date:'01-06-2019', from:'Mumbai', to:'Kolkata', fare:'77,000', additionalCharges:'7,500', shipperId:'ShipperID#'},
    { date:'01-06-2019', from:'Mumbai', to:'Nagpur', fare:'67,000', additionalCharges:'9,500', shipperId:'ShipperID#'},
    { date:'01-06-2019', from:'Mumbai', to:'Goa', fare:'80,000', additionalCharges:'6,500', shipperId:'ShipperID#'},
    { date:'01-06-2019', from:'Mumbai', to:'Ranchi', fare:'46,000', additionalCharges:'8,500', shipperId:'ShipperID#'}
  ]

  columnsToDisplayAdvanced: string[] = ['from', 'to', 'dateFrom', 'dateTo', 'fare', 'additionalCharges', 'shipperId']

  rateCardAdvancedArr = [
    { dateFrom:'01-06-2019', dateTo:'01-06-2019', from:'Mumbai', to:'Bengaluru', fare:'38,000', additionalCharges:'8,500', shipperId:'ShipperID#', timeFrom:'10:00AM', timeTo:'06:00PM'},
    { dateFrom:'01-06-2019', dateTo:'01-06-2019', from:'Mumbai', to:'Kolkata', fare:'77,000', additionalCharges:'7,500', shipperId:'ShipperID#', timeFrom:'10:00AM', timeTo:'06:00PM'},
    { dateFrom:'01-06-2019', dateTo:'01-06-2019', from:'Mumbai', to:'Nagpur', fare:'67,000', additionalCharges:'9,500', shipperId:'ShipperID#', timeFrom:'10:00AM', timeTo:'06:00PM'},
    { dateFrom:'01-06-2019', dateTo:'01-06-2019', from:'Mumbai', to:'Goa', fare:'80,000', additionalCharges:'6,500', shipperId:'ShipperID#', timeFrom:'10:00AM', timeTo:'06:00PM'},
    { dateFrom:'01-06-2019', dateTo:'01-06-2019', from:'Mumbai', to:'Ranchi', fare:'46,000', additionalCharges:'8,500', shipperId:'ShipperID#', timeFrom:'10:00AM', timeTo:'06:00PM'}
  ]*/

  showVehiclesTab = 0;
  selectedLane: any = {};

  vehicleColumns: string[] = [];
  rateCardArray = [];
  headerColumns: any = [];
  vehiclesList = [];
  shipperArray: any = [];
  selectedShipper: any = {
    _id: '',
    name: '',
    type: ''
  };
  rateFilters: any ={};
  carrierId: Subscription;
  currencySymbol: any;
  weightColumns = ['from', 'to', 'rate', 'minRate'];
  weightRateArray = [];
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private storage: StorageService, private route: Router, private http: HttpService, private timeService: TimeService,
              private snackbar: SnackbarService, private events: EventService, private valid: ValidationService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.getCarrierPref();
    this.getLinkedShippers();
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;

    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getLinkedShippers();
        const currencyChange = JSON.parse(localStorage.getItem('carriers'));
        this.currencySymbol = currencyChange[0].country.currency.symbol;
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  getLinkedShippers() {
    this.rateCardArray = [];
    this.showLoader = true;
    this.shipperArray = [];
    this.http.get('rate_card_list').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.showLoader = false;
          if (data.data.length) {
            const shippers = data.data;
            shippers.forEach(element => {
              const temp: any = {};

              temp._id = element.shipper._id;
              temp.name = element.shipper.parent_name + ' - ' + element.shipper.name;
              temp.type = element.type;
              this.shipperArray.push(temp);
            });
            this.selectedShipper = this.shipperArray[0];
            this.rateFilters.shipper = this.selectedShipper._id;
            this.getRatesForShipper();
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getCarrierPref() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.vehicle_types.length) {
            this.vehiclesList = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getRatesForShipper() {
    this.rateCardArray = [];
    this.rateFilters.shipper = this.selectedShipper._id;
    this.showLoader = true;

    this.http.get('rate_card', this.rateFilters).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.rateCardArray = [];
          this.weightRateArray = [];
          this.showLoader = false;
          if (response.data.type) {
            this.selectedShipper.type = response.data.type;
            this.selectedShipper.type_string = response.data.type.replace(response.data.type.charAt(0), response.data.type.charAt(0).toUpperCase());
          }

          if (response.data.sub_type) {
            this.selectedShipper.sub_type = response.data.sub_type;
            (response.data.sub_type != 'basic') ? this.selectedShipper.type_string += ' & ' +
                    response.data.sub_type.replace(response.data.sub_type.charAt(0), response.data.sub_type.charAt(0).toUpperCase()) : '';
          }

          if (response.data.type == 'weight' || response.data.type == 'package' || response.data.type == 'cbm') {
            this.weightRateArray = [];
            const result = response.data.rateCard;
            result.forEach(element => {
              const temp: any = {};
              temp.from = this.timeService.toShortDateTime(element.from_date, 'dd-MMM-yyyy');
              temp.to = this.timeService.toShortDateTime(element.to_date,'dd-MMM-yyyy');
              temp.rate = element.rate;
              temp.minRate = element.min_rate;
              this.weightRateArray.push(temp);
            });
          } else {
            this.vehicleColumns = ['from', 'to', 'fromDate', 'toDate'];
            this.headerColumns = [response.data.type, 'valid'];

            const ratesData: any = response.data.rateCard || [];

            ratesData.forEach((element, i) => {

              const temp: any = {
                vehicleRates : []
              };

              temp._id = element._id;
              temp.other_charges = element.other_charges;
              temp.fromLoc = element.from;
              temp.toLoc = element.to;
              temp.fromDate = (element.from_date) ? this.timeService.toShortDateTime(element.from_date, 'dd-MMM-yyyy') : '';
              temp.toDate = (element.to_date) ? this.timeService.toShortDateTime(element.to_date, 'dd-MMM-yyyy') : '';

              if (response.data.type == 'range') {
                temp.from = element.from;
                temp.to = element.to;
              } else if (response.data.type == 'lane') {
                temp.from = (element.from && element.from.name) ? element.from.name : 'NA';
                temp.to = (element.to && element.to.name) ? element.to.name : 'NA';
              } else {
                temp.from = (element.from && element.from.name) ? element.from.name + ' - ' + element.from.city : element.from.city;
                temp.to = (element.to && element.to.name) ? element.to.name + ' - ' + element.to.city : element.to.city;
              }
              temp.vehicleRates = element.rates;
              if (element.sub_type && element.sub_type == 'weight') {
                temp.weightRate = {
                  unit: element.weight_unit,
                  price: element.price,
                };
              }
              this.rateCardArray.push(temp);
              this.openVehiclesTab(this.rateCardArray[0]);

              // this.vehiclesList.forEach((vehicle, ind) => {
              //   if (i == 0) {
              //     this.vehicleColumns.push(vehicle.name);
              //     this.headerColumns.push(ind.toString());
              //   }
              //   element.rates.map(item => {
              //     (vehicle._id == item.vehicle_type._id) ?
              //               temp.vehicleRates[this.vehicleColumns.indexOf(item.vehicle_type.name)] = item.price : '';
              //   });
              // });

            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  openVehiclesTab(element) {
    this.showVehiclesTab = 1;
    this.selectedLane = element;
  }
}
